import { styled } from "@mui/material";

const MakeComplainTitle = styled('h4')`
  font-size: ${props => props.theme.customTheme.sizes.large};
  line-height: 1.4;
  margin-top: 0;
  margin-bottom: 0;
  background-color: #fff;
`;


const ComplaintWrapper = styled('div')`
  .make-complain-form {

    &__success {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    &__list {
      list-style: none;
      margin: 0;
      padding-left: 0;
    }

    &__item {
      &:not(:last-child) {
        margin-bottom: 0.5rem;
      }
    }

    &__err-text {
      color: ${props => props.theme.customTheme.colors.error};
    }

    &__checkbox {
      font-size: ${props => props.theme.customTheme.sizes.normal};
      user-select: none;
      line-height: 1.5;

      input {
        width: 16px;
        height: 16px;
      }
    }
  
    
    &__comment-wrapper {

    }

    &__comment-length {
      text-align: end;
      font-size: 14px;
    }
  }
`

export {
  ComplaintWrapper,
  MakeComplainTitle
};
